import { connect } from 'react-redux';
import { createNormalizedContentDataSelector } from 'selectors/learn/search';

const mapStateToProps = () => {
  const getContentData = createNormalizedContentDataSelector();
  return (state, { hit }) => ({
    contentData: getContentData(state, hit),
  });
};

const withContentData = Component => connect(mapStateToProps)(Component);

export default withContentData;
